import React from 'react';
import {Link} from "react-router-dom";
import Button from "@material-ui/core/Button";
import {withStyles} from '@material-ui/core/styles';

const styles = theme => ({
    message: {
        padding: theme.spacing.unit * 4,
        textAlign: 'center'
    },
    button: {
        margin: 'auto',
        width: '80%',
    },
});

function createBackButton(path, label) {
    const ButtonLink = props => <Link to={path} {...props} />;
    return (
        <Button component={ButtonLink} variant="contained" color="primary" fullWidth>{label}</Button>
    )
}

export class Logout extends React.Component {

    constructor(props) {
        super(props);

        // クッキーの認証情報を削除.
        this.props.cookies.remove('id');
        this.props.cookies.remove('role');
        this.props.cookies.remove('token');

        if (this.props.onScreen !== undefined) {
            this.props.onScreen('ログアウト画面');
        }
    }

    render() {
        return (
            <div>
                <div className={this.props.classes.message}>ログアウトしました。</div>
                <div className={this.props.classes.button}>
                    {createBackButton(this.props.backPath, "ログイン画面へ")}
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(Logout);
